var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9004704PrinterPrintPrintingOfficeWorkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#232323;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,5H19V3a3,3,0,0,0-3-3H8A3,3,0,0,0,5,3V5H4A4,4,0,0,0,0,9v8a4,4,0,0,0,4,4H5a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3h1a4,4,0,0,0,4-4V9A4,4,0,0,0,20,5ZM7,3A1,1,0,0,1,8,2h8a1,1,0,0,1,1,1V5H7ZM17,21a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V17H17Zm5-4a2,2,0,0,1-2,2H19V17a1,1,0,0,0,0-2H5a1,1,0,0,0,0,2v2H4a2,2,0,0,1-2-2V9A2,2,0,0,1,4,7H20a2,2,0,0,1,2,2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,9H5a1,1,0,0,0,0,2H6A1,1,0,0,0,6,9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,9H10a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9004704PrinterPrintPrintingOfficeWorkIcon);
export default __webpack_public_path__ + "static/media/9004704_printer_print_printing_office_work_icon.a3289969c5ae78e320e1ee46c013c8bf.svg";
export { ForwardRef as ReactComponent };